import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { StudentExpedienteView } from "@/features/academy/components/people/student-expediente-view";

function AcademyExpedientePage() {
  const params = useParams({ from: "/u/$u/academy/people/$userId" });
  return <StudentExpedienteView userId={params().userId} />;
}

export const academyPersonDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/people/$userId",
  component: AcademyExpedientePage,
});
